export const formatPriceWithCommas = (number) => {
    // Remove any non-digit characters from the number string
    let numberStr = String(number).replace(/\D/g, '');
    let chars = numberStr.split('');
    let result = '';
    let count = 0;
    for (let i = chars.length - 1; i >= 0; i--) {
        result = chars[i] + result;
        count++;
        if (count % 3 === 0 && i !== 0) {
            result = ',' + result;
        }
    }
    // If the original number had a dollar sign, add it back
    if (String(number).indexOf('$') !== -1) {
        result = '$' + result;
    }
    return result;
}